
import {getJackpotHistoryList} from '../api/getJackpotHistoryList';
import {setGetJackpotHistoryListAction} from '../action';
import { setLoadingAction } from '../../../components/templatePage/store/action';

const setGetJackpotHistoryList = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getJackpotHistoryList(params);

            if (data.status === 'success') {
                const jackpot = [...getState().usersMobile.list_jackpot.data];
                jackpot.push(data.data);
                dispatch(setGetJackpotHistoryListAction({
                    data: jackpot.flat(1),
                    countPage: data.countPage
                }));    
                dispatch(setLoadingAction(false))       
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetJackpotHistoryList
}